<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import mznmezunlar from "@/models/mznmezunlar";
import Banner from "../components/banner";
//import message from "./message.vue";

export default {
  mixins: [apibtoast, apigeneric, mznmezunlar],
  page: {
    title: "Web Siteleri",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    Banner,
   // message,
  },
  data() {
    return {
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "99999",
        PageDataSize: "1",
      },
      TableData: {},
      ArkadaslikIstekListesi: {},
      Arkadasuserid: null,
      Arkadasadisoyadi: null,
    };
  },
  methods: {
    Get() {
      this.ActionsFilterGet({
        Service: this.$config.API_URL_2 + "mznarkadaslistesi",
        Page: this.Page,
        Filter: "&Onay=true&Userid=" + this.TokenUserId,
      }).then((res) => {
        this.TableData = res.Data;
      });
      this.ActionsFilterGet({
        Service: this.$config.API_URL_2 + "mznarkadaslistesi",
        Page: this.Page,
        Filter: "&Onay=false&Userid=" + this.TokenUserId,
      }).then((res) => {
        this.ArkadaslikIstekListesi = res.Data;
      });
    },
    Onay(Data) {
      Data.Onay = true
      this.Update(this.$config.API_URL_2 + "mznarkadaslistesi", Data).then((res) => {
        console.log(res)
        if (Data.Onay == true) {
          let FormData = {
            Userid: Data.Arkadasuserid,
            Arkadasuserid: Data.Userid,
            Onay: true
          };
          this.Post(this.$config.API_URL_2 + "mznarkadaslistesi", FormData);
        }
      });
    }
  },
};
</script>

<template>
  <Loader>
    <Layout>
      <Banner />

      <div class="d-lg-flex mt-5">
        <div class="chat-leftsidebar me-lg-4">
          <div class>
            <div class="py-4 border-bottom">
              <div class="media">
                <div class="align-self-center me-3">
                  <img :src="
                    Avatar
                      ? Avatar
                      : 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAeCAMAAACR41cYAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAJ/UExURUdwTCEgIB8fHyAfHyAfHyAfHyAfHx8eHiAfHx8eHiAfHyAfHyAfHx8eHiAfH5jU5h8eHiAfHyAfHyAfHx8eHh8eHiAfHyAfIAQBAxgWFiEhISEgIAwCACAgIB0bGi40NhkVFCAfH5za8FBncENVXKTm95vZ8Jza8J7c8R0bGhMTEx0cHCAfHyEgH73//yEgIJ7c8QAAAIfF6TM7PwwJCh4cHHm45SAfHyAfH5za8CAfH5za8Jza8Jza8Jza8CAfH5za8G6VokRVWxIKCJza8JvY7pza8DtITTlFSZ3b8AMHCgAABJza8ElBPDA4PFVLRK3z/zEvLRcXGEVBPTA5PJza8AADB5vZ74XD6QIAAIrJ67T+/4HA6BAIByAfH4zK7IrI6zE4O7D5/yAfHwEAACIgIJza8BUWGAACBhoaGvXLsQ0PEZ/g957c8RATFf/oy1p4hfzRticqLIC+6Jrm///jxiMiIvDEq//Xu/bHq//fxG5eVRgXF////P/z0P/22lNHQv/gv//877H5/xcTEhUOC76cicyolCcjIf/avdivlpvY7mZaUQMHC1lNRfrNsPTJr//o0v/cwf3WuHtnXIshF4VuYvTEqfrcyM+oqOrW1PTm4v716zM7PqHf8v/t1SkpJsD//1RueGebxaPn/IXK/TVIV3OapbmXheK0mNuymv/GrdWZhu/Tx+u7pI54adymkf/658+dlMifn+S1mafq+7uhizYvLeLCufLs7/rk1mNVTf/NrtOskqeHd8aXlXFgVv/kwZU1LNW1neK9tJAuJsCMirJwa+nKv9zFx2CRtVuKronG6naszSUnKUZaZG+TmUFPU3agr3GkxIu8xSfH+3sAAABzdFJOUwD97RwqJTMat/4VL6DlCwmSOh2qV77yhGEIms8njIj9+xEk6wESA6CMcwRtUGQlwnjIs9iu9u3fsS5e3hvwhB66hguP9eJfotdT9nPf4o7mPNW62Kc/5MnTMeRzzcTG3/LkYv////////////////////54WQMpAAACTklEQVQYGXXABVMiYRgA4BdYdhkExa5TR8Xuvu7u7v5g2V06XFGxO7C72+vu7s74Qaczd87sIg/85yeUJMMCsUK+FFzIEEISvwSZxF8iSwpEczyBT4L4xMAXhniE4CIQ8QRgwCMWID458PgipEYag0ZD07TGYHCgOcuBI1GIWA3lqEcOrVbrUNdXUzSLfIHDB7EG7fXGi411tRdq6y7dedrl1KjTgGMNop3PSm+WGO35+fkNHSUlpT0U8geO4ABneUX7w9tXWxmGKXzU/7HyyX2tBLhCVT0vh/q7b7W3MW1Fb169H6p4TIXAP1IRQfiIMV/qRUXl8+4HHUwnY//w9l1lZ7kzHBP7EIRICpg3juMemLd2zGwcHOjrLbjB9PYNDI72sgYc88Bx3BsDQiSN9FQCpFDFxrKyVvO1KwXmwtGy0i4qBUDpGSkVEbDA73D5vYIGo/2y3Vhkfl28PQl4NoQABAdl79vV0lzc3LLnwP4dBPB4rbNkwbwM1byMRHAVk7qe3gIAyWpWIBCwKAgWFTS8dfdBQY5cIMsRsv6wuARLhIU+rUBhKCQgFNwIPrYkTR6uVqjD80LBvWxhIFKgsLxT4IYy9XyWJbo6ujo64tyJvbGwiM1H9OM/kalmosb0bXhct2m1F/DExpG6KZPqxy/Vd9XsrGriro5cEQVcUSSp05s+T0XU/HGM6T6Z9DqSjAcur7Vkk77KNjnzu+rrzKStSt9ErloGfOk7yRGr1Tb9ZdpmtY6QG+NWgivlofTMk2dyz+YeP5oZvy0GFvwFlSbPVswTomsAAAAASUVORK5CYII='
                  " class="avatar-xs rounded-circle" alt />
                </div>
                <div class="media-body">
                  <h5 class="font-size-15 mt-0 mb-1">{{ UserNameSurName }}</h5>
                </div>
              </div>
            </div>
          </div>

          <div class="chat-leftsidebar-nav mt-3">
            <b-tabs pills fill content-class="py-4">
              <b-tab title="Tab 1" active>
                <template v-slot:title>
                  <i class="bx bx-chat font-size-20 d-sm-none"></i>
                  <span class="d-none d-sm-block">Arkadaş Listesi</span>
                </template>
                <b-card-text>
                  <div>
                    <simplebar style="max-height: 410px" id="chat-list">
                      <ul class="list-unstyled chat-list">
                        <li class v-for="(Data, index) in TableData" :key="index">
                          <a href="javascript: void(0);" @click="
                            (Arkadasuserid = Data.Arkadasuserid),
                            (Arkadasadisoyadi = Data.Arkadasadisoyadi)
                          ">
                            <div class="media">
                              <div class="align-self-center me-3">
                                <i :class="`mdi mdi-circle text-  font-size-10`"></i>
                              </div>
                              <div class="align-self-center me-3">
                                <img v-if="Data.Arkadasavatar != null"
                                  :src="$config.FILES_URL + 'web/' + Data.Arkadasavatar" class="rounded-circle avatar-xs"
                                  alt />
                                <img v-if="Data.Arkadasavatar == null" src="@/assets/images/usericon.png"
                                  class="rounded-circle avatar-xs" alt="" />
                              </div>
                              <div class="avatar-xs align-self-center me-3"></div>
                              <div class="media-body overflow-hidden">
                                <h5 class="text-truncate font-size-14 mb-1">
                                  {{ Data.Arkadasadisoyadi }}
                                </h5>
                              </div>
                            </div>
                          </a>
                        </li>
                      </ul>
                    </simplebar>

                    <span v-if="TableData.length == 0">
                      Kayıt Bulunamadı
                    </span>
                  </div>
                </b-card-text>
              </b-tab>
              <b-tab title="Tab 1" active>
                <template v-slot:title>
                  <i class="bx bx-chat font-size-20 d-sm-none"></i>
                  <span class="d-none d-sm-block">Arkadaşlık İstekleri</span>
                </template>
                <b-card-text>
                  <div>
                    <simplebar style="max-height: 410px" id="chat-list">
                      <ul class="list-unstyled chat-list">
                        <li class v-for="(Data, index) in ArkadaslikIstekListesi" :key="index">
                          <a href="javascript: void(0);">
                            <div class="media">
                              <div class="align-self-center me-3">
                                <i :class="`mdi mdi-circle text-  font-size-10`"></i>
                              </div>
                              <div class="align-self-center me-3">
                                <img v-if="Data.Arkadasavatar != null"
                                  :src="$config.FILES_URL + 'web/' + Data.Arkadasavatar" class="rounded-circle avatar-xs"
                                  alt />
                                <img v-if="Data.Arkadasavatar == null" src="@/assets/images/usericon.png"
                                  class="rounded-circle avatar-xs" alt="" />
                              </div>
                              <div class="avatar-xs align-self-center me-3"></div>
                              <div class="media-body overflow-hidden">
                                <h5 class="text-truncate font-size-14 mb-1">
                                  {{ Data.Arkadasadisoyadi }}
                                </h5>
                              </div>
                              <div class="text-sm-end">
                                <i @click="Onay(Data)" v-tooltip="$t('mzneposta.Table.Onay')"
                                  class="fas fa-check-double"></i>
                              </div>
                            </div>
                          </a>
                        </li>
                      </ul>
                    </simplebar>
                    <span v-if="ArkadaslikIstekListesi.length == 0">
                      Kayıt Bulunamadı
                    </span>
                  </div>
                </b-card-text>
              </b-tab>
            </b-tabs>
          </div>
        </div>
        <div class="w-100 user-chat">
          <message v-if="Arkadasuserid" :Arkadasuserid="Arkadasuserid" :Arkadasadisoyadi="Arkadasadisoyadi" />
        </div>
      </div>
    </Layout>
  </Loader>
</template>
